import type { ComponentClassNames } from '../../../../util/classNames';
import type { Depth } from '../../../../util/styles/depth';
import { getDepthBoxShadow } from '../../../../util/styles/depth';
import { memoizeFunction, mergeStyleSets } from '../../../../util/styling';
import type { ColorToken } from '../../../../util/theme/fluent9';

type HeaderClassNames = ComponentClassNames<'header'>;

type GetClassNames = (depth: Depth, backgroundColor?: ColorToken) => HeaderClassNames;
export const getClassNames: GetClassNames = memoizeFunction(
  (depth: Depth, backgroundColor?: ColorToken): HeaderClassNames => {
    const boxShadow = getDepthBoxShadow(depth);

    return mergeStyleSets({
      header: {
        boxShadow,
        backgroundColor,
      },
    });
  }
);
